import { useSlider } from '@hooks/useSlider';
import { Children, ReactNode } from 'react';
import NavigationButtons from './NavigationButtons/NavigationButtons';
import SlideIndicators from './SlideIndicators/SlideIndicators';

import './Slider.css';

interface SliderProps {
	children: ReactNode;
	hasNavigation?: boolean;
	hasIndicators?: boolean;
	autoPlayInterval?: number;
}

const Slider = ({ children, hasNavigation = true, hasIndicators = true, autoPlayInterval }: SliderProps) => {
	const slides = Children.toArray(children);
	const slidesCount = slides.length;

	const { currentSlide, slidesContainerRef, handleSlideChange } = useSlider({
		slidesCount,
		autoPlayInterval
	});

	if (slidesCount === 0) return null;

	return (
		<div id="slider" role="region" aria-label="Content Slider">
			{hasNavigation && <NavigationButtons currentSlide={currentSlide} totalSlides={slidesCount} onSlideChange={handleSlideChange} />}
			<div className="slides-container" ref={slidesContainerRef}>
				{slides}
			</div>
			{hasIndicators && <SlideIndicators totalSlides={slidesCount} currentSlide={currentSlide} onSlideChange={handleSlideChange} />}
		</div>
	);
};

export default Slider;
